import { createContext, Dispatch, ReactElement, SetStateAction, useState } from 'react'
import { Languages } from '../../interfaces/common'

export const LocaleContext = createContext<{
  locale: Languages
  setLocale: Dispatch<SetStateAction<Languages>>
}>({
  locale: Languages.RU,
  // eslint-disable-next-line @typescript-eslint/no-empty-function, prettier/prettier
  setLocale: () => {},
})

interface ILocaleContextProvider {
  children: ReactElement
  defaultValue: Languages
}

export const LocaleContextProvider = ({ children, defaultValue }: ILocaleContextProvider) => {
  const [locale, setLocale] = useState<Languages>(defaultValue)

  return <LocaleContext.Provider value={{ locale, setLocale }}>{children}</LocaleContext.Provider>
}
